export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/83e791c702f67cc0242109b04d241be7.svg";